import { render } from "./CartRestoration.vue?vue&type=template&id=c3c74b74"
import script from "./CartRestoration.vue?vue&type=script&lang=js"
export * from "./CartRestoration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__